import { string, object, ObjectSchema, array, number } from 'yup';

import { ERROR_REQUIRED_FIELD_WITH_NAME } from '@/constants';

import { createNameofProxy } from '@/lib/ui/form';

import { IUserUpdate } from '@/features/user-management/user-management-update/interfaces';

const ERROR_REQUIRED_ROLES = ERROR_REQUIRED_FIELD_WITH_NAME('At least one Role');

export const USER_UPDATE_SCHEMA = object({
  fullName: string().required(ERROR_REQUIRED_FIELD_WITH_NAME('User Name')),
  roles: array().of(string()).required(ERROR_REQUIRED_ROLES).min(1, ERROR_REQUIRED_ROLES),
  status: number().required(ERROR_REQUIRED_FIELD_WITH_NAME('Status')),
}) as ObjectSchema<IUserUpdate>;

export const USER_UPDATE_FORM_FIELDS = createNameofProxy<IUserUpdate>();
